import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransfersListFilterDialogComponent } from 'src/app/components/dialogs/audiences/transfers-list-filter-dialog/transfers-list-filter-dialog.component';
import { Tag } from 'src/app/models/services/tag';
import { AudiencesListFilter } from 'src/app/models/ui/audiencesListFilter';

// Based on: https://darchuk.net/2019/01/11/angular-making-a-modal-service-by-extending-ngbmodal/
@Injectable({
  providedIn: 'root'
})
export class TransfersListFilterDialogService {
  lastErrorCloseResult: string;

  constructor(private modalService: NgbModal) { }

  public show = (currentFilter: AudiencesListFilter, acceptCallback: () => void, rejectCallback?: () => void): void => {    
    var ref = this.modalService.open(TransfersListFilterDialogComponent, { size: 'xl' });

    // Get the OkDialog from the NgbModal object  
    let dialog: TransfersListFilterDialogComponent = ref.componentInstance as TransfersListFilterDialogComponent;

    // Set the dialog's properties
    dialog.filter = currentFilter;
    dialog.accept = () => {
      ref.close(1); 
    };

    dialog.dismiss = () => {
      ref.dismiss(2);
    };

    ref.result.then((result) => {
      switch (result) {
        case 1:
          acceptCallback();
          break;
        default:
          if (rejectCallback)
            rejectCallback();
      }
    }, (reason) => {
      if (rejectCallback)
        rejectCallback();
    })
   
  }
}
